import { render, staticRenderFns } from "./DangKyChuongTrinhList.vue?vue&type=template&id=7435aac0&"
import script from "./DangKyChuongTrinhList.vue?vue&type=script&lang=js&"
export * from "./DangKyChuongTrinhList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports